export type Capability = { view: boolean; manage: boolean }
export type StaffCapabilities = Record<string, Capability>

export interface StaffIdentity {
  user: {
    seats: Array<{
      association_id: number
      capabilities: StaffCapabilities
    }>
  }
}

export type StaffModule =
  | 'contacts'
  | 'membership'
  | 'events'
  | 'communications'
  | 'segments'
  | 'finance'
  | 'payment_settings'
  | 'association_settings'
  | 'affiliations'
  | 'groups'
  | 'courses'
  | 'connections'
  | 'connection_unmatched'

export function capabilityFor(capabilities: StaffCapabilities, module: StaffModule): Capability {
  return capabilities[module] ?? { view: false, manage: false }
}

export function canView(capabilities: StaffCapabilities, module: StaffModule) {
  return capabilityFor(capabilities, module).view
}

export function canManage(capabilities: StaffCapabilities, module: StaffModule) {
  return capabilityFor(capabilities, module).manage
}

export function isViewOnly(capabilities: StaffCapabilities, module: StaffModule) {
  return canView(capabilities, module) && !canManage(capabilities, module)
}

export function isViewOnlyRole(capabilities: StaffCapabilities) {
  const entries = Object.values(capabilities)
  return entries.length > 0 && entries.every(({ view, manage }) => view && !manage)
}
